(ns app.front.view.admin.reporting.core
  (:require [app.domain.payment.provider.model :as pp-model]
            [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.front.view.admin.common :as admin.common]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.list :as report-list]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::query
  :<- [::reporting-common/date-range]
  (fn [[start-date end-date] _]
    (util/mmap start-date end-date)))

(rf/reg-event-fx ::fetch-admin-reports
  (fn [_ _]
    {:comm/command {:command    :report/list-admin-reports
                    :method     :get
                    :on-success [::entities/merge-entity-db]}}))

(rf/reg-event-fx ::get-b-groups-with-inspections
  (fn [_]
    {:dispatch [:comm/command-monitored
                {:command    :report/customers-for-admin-report
                 :method     :get
                 :data       {:with-inspections true
                              :with-permit-type :permit-type/B}
                 :on-success [::get-b-groups-with-inspections.success]}]}))

(rf/reg-event-db ::get-b-groups-with-inspections.success
  (fn [db [_ _ groups]]
    (assoc-in db [::data ::groups-with-inspections] groups)))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::groups-with-inspections
  :<- [::data]
  :-> ::groups-with-inspections)

(rf/reg-event-db ::set-month-year
  (fn [db [_ month-year]]
    (assoc-in db [::data ::month-year] month-year)))

(rf/reg-sub ::month-year
  :<- [::data]
  (fn [data _]
    (::month-year data (reporting-common/current-year-month true))))

(rf/reg-sub ::payment-provider
  :<- [::data]
  :-> ::payment-provider)

(rf/reg-event-db ::set-payment-provider
  (fn [db [_ provider]]
    (assoc-in db [::data ::payment-provider] provider)))

(defn view [match]
  (let [tr (<sub [:tr])]
    [acommon/admin-page
     (util/mmap {:title (tr [:view/admin.reporting])} match)
     [:section
      [:h2 "Municipality and circulation group user list"]
      [rdb/generate-button
       (util/mmap {:query {:report-type :reporting.admin/users-report-full}}
                  tr)]
      [report-list/list-section {:report-type :reporting.admin/users-report-full
                                 :tr          tr}]]
     [:section
      [:h2 "Transaction report"]
      [:div.mb-8
       [reporting-common/date-range-selector tr "transaction-date-range" reporting-common/date-range-options]]
      [rdb/generate-button
       (util/mmap {:query (merge (<sub [::query])
                                 {:report-type :reporting.admin/transaction-report})}
                  tr)]
      [report-list/list-section {:report-type :reporting.admin/transaction-report
                                 :tr          tr}]]
     [:section
      [:h2 "Workspace totals per product"]
      [rdb/generate-button
       (util/mmap {:query {:report-type :reporting.admin/workspace-totals-report}}
                  tr)]
      [report-list/list-section {:report-type :reporting.admin/workspace-totals-report
                                 :tr          tr}]]
     (let [month-year (<sub [::month-year])]
       [:section
        [:h2 "Workspaces created monthly per group & product"]
        [:div.-m-4
         [reporting-common/month-select-with-button
          (util/mmap {:title     "Start month"
                      :on-change (fn [month year]
                                   (>evt [::set-month-year (util/mmap month year)]))}
                     tr)]]
        [rdb/generate-button
         (util/mmap {:query (merge {:report-type :reporting.admin/workspaces-created-per-month-report}
                                   month-year)}
                    tr)]
        [report-list/list-section {:report-type :reporting.admin/workspaces-created-per-month-report
                                   :tr          tr}]])

     (let [selected-group (<sub [::admin.common/selected-group])]
       [:section
        [:h2 "Inspection report extraction"]
        [:div.mb-2.w-96
         (if (<sub [:comm/command-processing? :admin/get-authority-groups])
           (cc/select-skeleton {})
           [admin.common/group-selector {:title-text          "Select group"
                                         :tr                  tr
                                         :groups-subscription [::groups-with-inspections]}])]
        [:div.mb-8
         [reporting-common/date-range-selector tr "inspection-date-range" reporting-common/date-range-options]]
        [rdb/generate-button
         (util/mmap {:query    (merge (<sub [::query])
                                      {:group-id    (:id selected-group)
                                       :report-type :reporting.admin/inspector-ai})
                     :disabled (nil? selected-group)}
                    tr)]
        [report-list/list-section {:report-type :reporting.admin/inspector-ai
                                   :tr          tr}]])

     (let [selected-provider (<sub [::payment-provider])]
       [:section
        [:h2 "Payment provider listing by group"]
        [:div.mb-2.w-96
         [ui-select/select {:id           "payment-system-type"
                            :class        "mb-4 w-full"
                            :label-text   "Payment provider"
                            :value        selected-provider
                            :on-change    #(>evt [::set-payment-provider %])
                            :values       (sort (keys pp-model/provider->schema))
                            :val->str     (comp tr vector)
                            :allow-empty? true
                            :select-text  "Any"}]]
        [rdb/generate-button
         (util/mmap {:query (p/assoc-if {:report-type :reporting.admin/payment-providers}
                                        :payment-provider
                                        selected-provider)}
                    tr)]
        [report-list/list-section {:report-type :reporting.admin/payment-providers
                                   :tr          tr}]])]))

(def route
  {:name        :view/admin.reporting
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-admin-reports])
                           (>evt [::get-b-groups-with-inspections]))}]})
